import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)



// WEBPACK FOOTER //
// ./resources/js/plugins/vue-mask.js